import React, {useEffect, useState} from 'react';

import AbstractWindow from './AbstractWindow';

import { useParams, useHistory } from 'react-router-dom';

import { getConfigurationDetail } from '../../api/cars';

import TimesIcon from '../icons/TimesIcon';

const ConfigurationDetailWindow = () => {

    const { configurationId } = useParams();

    const [ state, setState ] = useState( {} );

    const history = useHistory();

    useEffect( () => {

        getConfigurationDetail( configurationId ).then( data => setState( data ) )

    }, [] )

    return <AbstractWindow id={ 'configuration-detail' } className="d-flex align-items-center justify-content-center" style={{backgroundColor:"#eeeeee66"}}>
        <div className="bg-white d-flex p-2 rounded-4 align-items-start" style={{minWidth:500, gap:10}}>
            <div className="rounded-4 overflow-hidden lh-0">
                { state.image && <img src={ state.image } /> }
            </div>
            <div className="flex-grow-1 d-flex flex-column pos-rel" style={{gap:4}}>
                { state.data && Object.keys( state.data ).map( body_slug => {
                    let option_value = state.data[ body_slug ];
                    let body_label = state.group_labels[ body_slug ];
                    return body_slug == "id" ? null : <div key={`option-value-${ option_value.id }`} className="rounded-4 d-flex p-1" style={{backgroundColor:'#eeeeee'}} >
                        <div className="pr-2">
                            <h5 className="bold">{body_label}:</h5>
                        </div>
                        <div className="flex-grow-1">
                            <h5 className="">{option_value.label}</h5>
                            {/* <img width={80} src={option_value.thumbnail} /> */}
                        </div>
                    </div>
                })}
                <button onClick={ e =>{ e.stopPropagation(); history.goBack() }} className="bg-black pos-abs z-3 text-white rounded-4 p-1" style={{top:-40, right:-40}}><TimesIcon /></button>
            </div>
        </div>
    </AbstractWindow>
}

ConfigurationDetailWindow.propTypes = {
}

export default ConfigurationDetailWindow;